var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "#545454",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9652 0.34361C18.7707 -0.0981094 18.2151 -0.115778 17.9824 0.301205C16.906 2.2059 14.9787 3.39324 12.7771 3.39324H9.99905C6.31814 3.39324 3.33175 6.43226 3.33175 10.178C3.33175 10.4254 3.35953 10.6622 3.38384 10.9025C5.59933 9.28754 8.79755 7.91644 13.3327 7.91644C13.6383 7.91644 13.8883 8.17087 13.8883 8.48184C13.8883 8.79281 13.6383 9.04724 13.3327 9.04724C4.6027 9.04724 0.900964 14.4928 0.0814413 16.5388C-0.147747 17.1148 0.123112 17.7721 0.689138 18.0088C1.25864 18.2491 1.90453 17.97 2.14066 17.3975C2.19275 17.2703 2.86643 15.7048 4.63743 14.1959C5.76254 15.7472 7.90163 17.2279 10.7109 16.924C16.1628 16.5211 20 11.5456 20 5.45342C20 3.67947 19.625 1.84192 18.9652 0.34361Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoSaving);
export default __webpack_public_path__ + "static/media/eco-saving.41f6618c821c88d19895193587db6e82.svg";
export { ForwardRef as ReactComponent };